import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RevenuePage } from '../screens/admin/RevenuePage';
import { periodSearch } from '../screens/admin/period-search';

const searchSchema = z.object({
  ...periodSearch,
  /** What the ledger sorts the companies by, and which way; net, largest first, when absent. */
  sort: z.enum(['net', 'cost', 'pages', 'costPerPage', 'name']).optional().catch(undefined),
  dir: z.enum(['asc', 'desc']).optional().catch(undefined),
  /** Where the page of companies starts; the first page when absent. */
  offset: z.number().int().min(0).optional().catch(undefined),
});

export const Route = createFileRoute('/admin/revenue')({
  validateSearch: searchSchema,
  component: RevenuePage,
});
